import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Button } from '@material-ui/core'

import useStyles from './styles'

const ButtonLink = ({ children, className, onClick, ...rest }) => {
  const classes = useStyles()

  return (
    <Button
      disableRipple
      className={clsx(classes.root, className)}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  )
}

ButtonLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default ButtonLink
